<mat-form-field class="w-100">
	<input
		autocomplete="off"
		matInput
		[required]="required"
		[readonly]="readonly"
		placeholder="Customer"
		[formControl]="customer"
		[matAutocomplete]="customerTypeAhead"
	/>
	<mat-autocomplete
		[displayWith]="displayName"
		(optionSelected)="optionSelected.emit($event.option.value)"
		#customerTypeAhead="matAutocomplete"
	>
		<mat-option
			*ngFor="let customer of filteredCustomers$ | async"
			[value]="customer"
		>
			{{ displayName(customer) }}
		</mat-option>
	</mat-autocomplete>
	<mat-error>Required</mat-error>
</mat-form-field>
